<template>
    <div class="" style="background-image: url('/WholisticLife.jpg')">
        <div class="uk-padding-large" style="background-color: rgba(251, 251, 251, 0.9)">
            <div class="uk-container">
                <h3 class="uk-text-center ">Study Online</h3>
                <p class="uk-text-small uk-text-center ">
                    We deliver many degrees, certificates and diplomas online to aid you to be able to study from the comfort of your own home.
                </p>

                <div class="uk-text-center">
                    <a href="#" class="uk-button uk-button-link uk-margin-right yellow uk-text-capitalize"> Undergraduate Programs</a>
                    <a href="#" class="uk-button uk-button-link uk-margin-right yellow uk-text-capitalize"> Certificates</a>
                    <a href="#" class="uk-button uk-button-link uk-margin-right yellow uk-text-capitalize"> Diplomas</a>
                </div>
                <br><br>
                <div class="uk-text-center">
                    <a href="#" class="uk-button uk-button-default uk-margin-right " style="border: 1px solid silver;">Learn More  <span style="margin-top: -2px" uk-icon="chevron-right"></span></a>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "onlineAdmission"
    }
</script>

<style scoped>
    .yellow{
        border-bottom: 1px solid gold;
        font-size: large;
        color: #033860;
        font-weight: bold;
    }
    @media screen and (max-width:600px){


        h3{
            font-size: 1.1em !important;
        }
        p,li{
            font-size: 0.8em !important;
        }
        img{
            height: 40px !important;
        }

    }
</style>
